module.exports = "/assets/images/b7a1157b1500b895db928974fba8b31e.svg";